import moment from 'moment';

export const TIME_FORMAT_RELATIVE = 'relative';
export const TIME_FORMAT_TIMESTAMP = 'timestamp';

export const DEFAULT_TIME_FORMAT = TIME_FORMAT_RELATIVE;
export const DEFAULT_TIMESTAMP_FORMAT = 'ddd, M/D/YYYY h:mma';

export function getUserPreferences() {
  try {
    const user = JSON.parse(localStorage.getItem('authUser'));
    return user?.preferences || {};
  } catch (error) {
    return {};
  }
}

export function getTimeFormat() {
  const preferences = getUserPreferences();
  return preferences.time_format || DEFAULT_TIME_FORMAT;
}

export function formatTime(value, options = {}) {
  if (value == null) return '';

  const date = moment(value);
  if (!date.isValid()) return '';

  if (getTimeFormat() === TIME_FORMAT_TIMESTAMP) {
    return date.format(options.timestampFormat || DEFAULT_TIMESTAMP_FORMAT);
  }

  return date.fromNow();
}

export function updateStoredPreferences(preferences) {
  const user = JSON.parse(localStorage.getItem('authUser'));
  const nextUser = {
    ...user,
    preferences: {
      ...(user?.preferences || {}),
      ...preferences,
    },
  };

  localStorage.setItem('authUser', JSON.stringify(nextUser));
  return nextUser;
}
